module.exports = __webpack_public_path__ + "img/planters_punch.f5db9b67.jpg";